import useResponsive from "utils/hooks/useResponsive";
import { useLayoutEffect, useState } from "react";

const useSlidesPerView = ({
  mobile = 2,
  tab = 3,
  tabLand = 5,
  desktop = 7
} = {}) => {
  const [slidesPerView, setSlidesPerView] = useState(8);

  const {
    isMobile,
    isTab,
    isTabLand,
    isDesktop,
  } = useResponsive();

  useLayoutEffect(() => {
    if (isMobile) {
      setSlidesPerView(mobile);
  
    } else if (isTab) {
      setSlidesPerView(tab);
      
    } else if (isTabLand) {
      setSlidesPerView(tabLand);
      
    } else if (isDesktop) {
      setSlidesPerView(desktop);
    }
  }, [
    isMobile,
    isTab,
    isTabLand,
    isDesktop,
    mobile,
    tab,
    tabLand,
    desktop
  ]);

    return { slidesPerView };
};

export default useSlidesPerView;